var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkflowFinalApproval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#6BB700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.138 6.195c.26.26.26.683 0 .943L16.47 9.805a.667.667 0 01-.943 0L14.195 8.47a.667.667 0 11.943-.942L16 8.39l2.195-2.196c.26-.26.683-.26.943 0zM8.506 13.333h2.988c.537 0 .98 0 1.34.03.375.03.72.096 1.043.261.502.256.91.664 1.165 1.165.165.324.231.668.262 1.043.03.36.03.804.03 1.34 0 .189.008.38-.008.568a1.004 1.004 0 01-.102.38 1 1 0 01-.437.438 1.005 1.005 0 01-.38.102c-.084.007-.179.007-.258.007H5.85c-.08 0-.174 0-.258-.007a1.005 1.005 0 01-.38-.102 1 1 0 01-.438-.437 1.005 1.005 0 01-.102-.381c-.015-.188-.007-.38-.007-.567 0-.537 0-.98.03-1.34.03-.376.096-.72.261-1.044.256-.501.664-.91 1.165-1.165.324-.165.669-.23 1.043-.261.361-.03.804-.03 1.34-.03zM7 9a3 3 0 116 0 3 3 0 01-6 0z",
    fill: "#fff"
  })));
}
export default SvgIconWorkflowFinalApproval;